export const MAIN_FLIGHT_STATUS_TEST_IDS = {
  // ─── Flight Status Tab Container ───
  tabContainer: 'main-flight-status-tab-container',
  heading: 'main-flight-status-heading',
  infoMessage: 'main-flight-status-info-message',

  // ─── Mode Toggle ───
  modeRadio: 'main-flight-status-mode-radio',
  modeRoute: 'main-flight-status-mode-route',
  modeFlight: 'main-flight-status-mode-flight',

  // ─── Form Fields ───
  originSelect: 'main-flight-status-origin-select',
  destinationSelect: 'main-flight-status-destination-select',
  exitDate: 'main-flight-status-exit-date',

  // ─── Actions ───
  clearButton: 'main-flight-status-clear-btn',
  checkStatusButton: 'main-flight-status-check-btn',
} as const;
